var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticStyle:{"justify-content":"center"},attrs:{"app":"","dark":"","color":_vm.$vuetify.theme.themes.dark.primary}},[_c('div',{staticClass:"footer-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('footerText'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }